import api from '@/api/api'
const state = {
  userInfo: null,
  freeNum: 20000,
  freeReduce:0,
  payReduce:0
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  getUserInfo({ commit }) {
    console.log('vuex用户=')
    api.getUserinfo().then(res => {
      if (res.code === 200) {
        commit('CHANGE_SETTING', { key: 'userInfo', value: res.data })
        commit('CHANGE_SETTING', { key: 'freeNum', value: res.data?.freeWordCount })
        commit('CHANGE_SETTING', { key: 'freeReduce', value: res.data?.freeReduce })
        commit('CHANGE_SETTING', { key: 'payReduce', value: res.data?.payReduce })
      } else {
        commit('CHANGE_SETTING', { key: 'userInfo', value: null })
        api.getGive().then(res => {
          if (res.code === 200) {
            commit('CHANGE_SETTING', { key: 'freeNum', value: res.data })
             commit('CHANGE_SETTING', { key: 'freeReduce', value: res.data?.freeReduce })
              commit('CHANGE_SETTING', { key: 'payReduce', value: res.data?.payReduce })
          }
        })
      }
    }).catch(() => {
      commit('CHANGE_SETTING', { key: 'userInfo', value: null })
      api.getGive().then(res => {
        if (res.code === 200) {
          commit('CHANGE_SETTING', { key: 'freeNum', value: res.data })
          commit('CHANGE_SETTING', { key: 'freeReduce', value: res.data?.freeReduce })
          commit('CHANGE_SETTING', { key: 'payReduce', value: res.data?.payReduce })
        }
      })
    })

  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

